var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 28,
    viewBox: "0 0 82 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6802 13.6055H16.2065V18.5418C15.1062 18.8942 13.717 19.0874 12.2728 19.0874C6.41996 19.0874 2.98004 14.0921 2.98004 9.21363C2.98004 4.42885 6.09151 1.0726 10.4324 1.0726C13.1793 1.0726 14.7776 2.00006 16.2075 3.29198V4.90251L18.8887 2.2303C17.1928 1.08677 14.7372 0 11.2272 0C3.52198 0 0 5.49403 0 10.0091C0 16.4358 4.69673 20.3073 10.5989 20.3073C13.4608 20.3073 16.0018 19.8719 18.937 19.0579V13.9579C18.937 13.6971 19.0519 13.5182 19.2238 13.3611L20.15 12.438H13.8604L12.6802 13.6055Z",
    fill: "url(#paint0_linear_628_92)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4772 6.89709C24.0421 6.89709 21.2942 10.127 21.2942 13.5554C21.2942 16.5146 23.508 20.028 27.9933 20.028C32.3079 20.028 34.9552 16.7917 34.9552 13.3033C34.9552 10.0539 32.3682 6.89829 28.4772 6.89829V6.89709ZM27.7414 7.83877C30.8682 7.83877 32.2608 11.8989 32.2608 14.7948C32.2608 19.1016 29.019 19.1867 28.6315 19.1867C27.148 19.1867 26.1112 18.2931 25.3351 17.1211C24.6519 16.041 23.9841 14.0343 23.9841 12.0735C23.9841 10.1204 24.6256 9.16669 25.6351 8.46508C26.4606 7.93915 27.2335 7.83877 27.7403 7.83877H27.7414Z",
    fill: "url(#paint1_linear_628_92)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4689 6.89606C53.5953 6.89606 51.4999 9.34024 51.4999 12.0692C51.4999 14.1467 52.9931 16.4905 56.0739 16.4905H56.8533C56.8533 16.4905 56.6411 17.0045 56.64 17.5009C56.64 18.2332 56.9038 18.6444 57.4643 19.2773C52.1632 19.5992 50.0327 21.7302 50.0327 24.0205C50.0327 26.0262 51.9597 28 56.0093 28C60.8034 28 63.2864 25.3473 63.2864 22.744C63.2864 20.9087 62.369 19.9026 60.0458 18.1677C59.3627 17.6385 59.2302 17.3015 59.2302 16.9054C59.2302 16.338 59.5707 15.9625 59.6955 15.8208C59.9155 15.5894 60.2965 15.3254 60.4388 15.1988C61.2194 14.5398 62.3219 13.5644 62.3219 11.6177C62.3219 10.2821 61.7645 9.13313 60.4947 8.05726H62.0449L63.2098 6.8963H57.4689V6.89606ZM56.4003 7.7646C57.1032 7.7646 57.6899 8.01232 58.3096 8.52625C58.997 9.14384 60.0953 10.8035 60.0953 12.857C60.0953 15.0731 58.3677 15.6798 57.4327 15.6798C56.9751 15.6798 56.4267 15.5521 55.9624 15.2357C54.9311 14.5691 53.9074 12.7948 53.9074 10.6834C53.9074 8.77828 55.046 7.7646 56.4003 7.7646ZM57.9341 20.1186C58.2296 20.1186 58.4422 20.1427 58.4422 20.1427C58.4422 20.1427 59.1395 20.6392 59.6267 21.01C60.7609 21.9037 61.4681 22.5868 61.4681 23.8035C61.4681 25.4762 59.9112 26.7878 57.3899 26.7878C54.6223 26.7878 52.5071 25.5035 52.5071 23.4064C52.5071 21.6692 53.9566 20.1741 57.9341 20.1186Z",
    fill: "url(#paint2_linear_628_92)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0486 19.6448H69.3661L70.1761 18.8375L68.651 18.6476C68.2405 18.5974 67.9965 18.2439 67.9965 17.9013V1.89308C67.9965 1.57774 68.1432 1.41625 68.2504 1.31357L69.2095 0.357727H64.6748L63.4946 1.53399H65.2573V18.1161C65.2573 18.3518 65.1828 18.5122 65.023 18.677L64.0486 19.6448Z",
    fill: "url(#paint3_linear_628_92)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.571 6.89709C73.6019 6.89709 70.4478 9.1525 70.4478 13.2017C70.4478 16.546 72.7107 20.028 76.9389 20.028C77.9932 20.028 78.8614 19.8928 79.6748 19.5207C80.5474 19.1202 81.3871 18.4699 82.0001 17.6526C80.843 18.2342 79.8992 18.6161 78.6456 18.6161C76.2633 18.6161 73.9663 16.903 73.1627 13.754L81.5785 10.3638C81.0925 8.63649 79.7218 6.89709 76.5721 6.89709H76.571ZM76.0213 7.82348C77.6144 7.82348 78.766 9.12959 78.766 10.152C78.766 10.4826 78.5581 10.6572 78.1463 10.8187L72.9733 12.9039C72.9733 12.9039 72.8333 12.2546 72.8333 11.553C72.8333 8.61021 74.9682 7.82348 76.0213 7.82348Z",
    fill: "url(#paint4_linear_628_92)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5263 6.89709C39.0912 6.89709 36.3433 10.127 36.3433 13.5554C36.3433 16.5146 38.5571 20.028 43.0424 20.028C47.357 20.028 50.0042 16.7917 50.0042 13.3033C50.0042 10.0539 47.4172 6.89829 43.5263 6.89829V6.89709ZM42.7905 7.83877C45.9174 7.83877 47.3098 11.8989 47.3098 14.7948C47.3098 19.1016 44.0681 19.1867 43.6806 19.1867C42.1971 19.1867 41.1603 18.2931 40.3842 17.1211C39.7011 16.041 39.0332 14.0343 39.0332 12.0735C39.0332 10.1204 39.6746 9.16669 40.6842 8.46508C41.5096 7.93915 42.2826 7.83877 42.7894 7.83877H42.7905Z",
    fill: "url(#paint5_linear_628_92)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_628_92",
    x1: 10.0249,
    y1: -0.0574845,
    x2: 10.0249,
    y2: 20.3062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196EEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#186DEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1065E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_628_92",
    x1: 28.075,
    y1: 6.86599,
    x2: 28.075,
    y2: 20.0335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DB4632"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D13D29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_628_92",
    x1: 56.6109,
    y1: 6.86604,
    x2: 56.6109,
    y2: 28.0081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A6FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#1E72EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#166BEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1267E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1063E5",
    stopOpacity: 0.87
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_628_92",
    x1: 66.7869,
    y1: 0.312328,
    x2: 66.7869,
    y2: 19.6634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AA561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#009B58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00914B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_628_92",
    x1: 76.1757,
    y1: 6.86599,
    x2: 76.1757,
    y2: 19.9972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DA4531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE3A28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_628_92",
    x1: 43.1245,
    y1: 6.89459,
    x2: 43.1245,
    y2: 20.0074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFBA03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB300"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.35d4255f8cad1e2995933639df7f9cc4.svg";
export { ForwardRef as ReactComponent };